import { OptionT } from "./types/filter.types"

// Separates an option's key from its cached label in one value ("key|label").
const DELIMITER = "|"

export function encodeQueryParam(option: OptionT, cacheValue: boolean): string {
  if (cacheValue) {
    return [option.key, option.value].filter(Boolean).join(DELIMITER)
  }
  return option.key
}

export function decodeQueryParam(queryParam: string): OptionT {
  const [key, value] = queryParam.split(DELIMITER)
  return { key, value: value ?? "" }
}
